import * as React from "react";
import * as moment from "moment";

var CommentItem = function CommentItem(props) {
  var comment = props.comment,
      admin = props.admin,
      onEdit = props.onEdit,
      onDelete = props.onDelete;

  var formatDate = function formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD-MM-YYYY HH:mm");
  };

  var canEdit = admin.is_super_admin || admin.permissions_code.includes("poliza_comment_edit");
  var canDelete = admin.is_super_admin || admin.permissions_code.includes("poliza_comment_delete");
  return /*#__PURE__*/React.createElement("div", {
    className: "comment-item",
    style: {
      marginBottom: "15px",
      padding: "15px",
      border: "1px solid #e0e0e0",
      borderRadius: "6px",
      backgroundColor: "#fff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      whiteSpace: "pre-wrap",
      fontSize: "14px",
      marginBottom: "10px",
      color: "#333",
      lineHeight: "1.6"
    }
  }, comment.content), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#666",
      marginBottom: "8px",
      paddingTop: "10px",
      borderTop: "1px solid #f0f0f0"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Creado por:"), " ", comment.created_by_email || "Desconocido", " el ", formatDate(comment.created_at)), comment.updated_by_id && comment.updated_by_id !== comment.created_by_id && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "4px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Editado por:"), " ", comment.updated_by_email || comment.created_by_email, " el ", formatDate(comment.updated_at))), (canEdit || canDelete) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "10px",
      display: "flex",
      gap: "8px"
    }
  }, canEdit && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-xs btn-secondary",
    onClick: onEdit,
    style: {
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, "Editar"), canDelete && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-xs btn-danger",
    onClick: onDelete,
    style: {
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, "Eliminar")));
};

export default CommentItem;